import { render, staticRenderFns } from "./_SimplePublication.vue?vue&type=template&id=a345ddb4&scoped=true&"
import script from "./_SimplePublication.vue?vue&type=script&lang=js&"
export * from "./_SimplePublication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a345ddb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/render/project/src/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
installComponents(component, {VCardText})
